module.exports = __webpack_public_path__ + "static/aman-10dacd4250fa807c66c2cb46a48d5a5a.png";